import BasketViewCheckoutSFC from "./BasketViewCheckout.vue";
export const BasketViewCheckout = BasketViewCheckoutSFC;
